import React from 'react';
import {Input, InputGroup, InputGroupAddon} from 'reactstrap';
import './inputSearch.sass';

const InputSearch = React.forwardRef((props, ref) => {
  return (
    <InputGroup id="search" size="sm" {...props}>
      <Input ref={ref} {...props} />
      <InputGroupAddon addonType="prepend">
        <span className="fal fa-search" />
      </InputGroupAddon>
    </InputGroup>
  );
});

export default InputSearch;
